export default function Footer() {
  return (
    <footer className="bg-teal text-white relative overflow-hidden">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center md:items-start justify-center gap-8 md:gap-16">
            <div className="flex-shrink-0">
              <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-white/15 flex items-center justify-center">
                <span className="font-heading font-bold text-white text-4xl md:text-5xl">A</span>
              </div>
            </div>
            <div className="text-center md:text-left">
              <h3 className="font-heading font-bold text-white text-lg mb-3">Aria Property Improvement, LLC</h3>
              <div className="font-body text-white/80 text-sm space-y-1">
                <p>2731 NE 14 Street</p>
                <p>Building B, 428</p>
                <p>Pompano Beach, FL 33062</p>
                <p>pokinkar@bellsouth.net</p>
                <p>954-560-2181</p>
              </div>
              <div className="flex items-center gap-3 mt-4 justify-center md:justify-start">
                <a href="#" className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors" aria-label="Facebook">
                  <i className="ri-facebook-fill text-white text-xs"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors" aria-label="Instagram">
                  <i className="ri-instagram-line text-white text-xs"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors" aria-label="Yelp">
                  <i className="ri-star-fill text-white text-xs"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/20">
        <div className="w-full px-4 md:px-8 lg:px-12 py-4 flex flex-col sm:flex-row items-center justify-center gap-2">
          <p className="font-body text-white/70 text-xs">
            &copy; {new Date().getFullYear()} Aria Property Improvement LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}